import { setCheckButtons, setTableButtons } from '@/utils/getbuttons.js'
import { resetAttribute } from '../handleData'

const user = {
  pageTabs: [
    {
      label: '机构用户',
      theme: 'user',
      step: 'organUserList',
      stepLabel: '机构用户列表',
      checkFun: 'user/getSystemOrganUser'
    },
    {
      label: '个人用户',
      theme: 'user',
      step: 'personUserList',
      stepLabel: '个人用户列表',
      checkFun: 'user/getSystemPersonUser'
    },
    {
      label: '管理员列表',
      theme: 'user',
      step: 'orgAdminList',
      stepLabel: '管理员列表',
      checkFun: 'user/getOrgAdmin'
    }
  ],
  organUser: {
    name: 'organUser',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'dialogForm',
      'setRole'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    getListFun: 'user/getSystemOrganUser',
    detailPage: [
      {
        buttonName: '编辑',
        type: 'dialogForm',
        name: 'organUser',
        checkType: 'useRowData'
      },
      {
        buttonName: '配置角色',
        type: 'other',
        name: 'setRolse',
        step: 'setRolseInfo',
        theme: 'user',
        label: '配置角色信息',
        checkType: 'useRowData'
      }
    ],
    queryParams: {
      userType: '',
      queryName: ''
    },
    selectData: [
      {
        key: 'userType',
        label: '用户类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.userType.filter((item) => item.value !== 'per')
        },
        checkByValue: true
      },
      {
        key: 'queryName',
        label: '关键词',
        type: 'input',
        placeholder: '机构名称'
      }
    ],
    rowKey: 'userUid',
    selectColumn: true,
    headButtons: setCheckButtons(['批量封禁', '批量解禁']),
    rowData: (params) => {
      return params.state.user.organUserList.result
    },
    rowTotal: (params) => {
      return params.state.user.organUserList.totalSize
    },
    columns: [
      { prop: 'userName', label: '用户名', width: '' },
      { prop: 'orgCode', label: '机构名称', width: '300px' },
      {
        prop: 'userTypeName',
        label: '用户类型',
        tag: (params) => {
          return params.dictionarys.userType
        }
      },
      { prop: 'roleName', label: '用户角色', width: '400px' },
      {
        prop: 'accountStatusName',
        label: '状态',
        width: '90px',
        tag: [
          { label: '正常', type: 'success' },
          { label: '封禁', type: 'danger' }
        ]
      },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '封禁', '解禁', '配置角色', '密码初始化']),
        width: '380px'
      }
    ],
    hasPagination: true,
    tagInfo:
      '机构用户名规则：去掉“有限公司、股份有限公司、集团、标段”等后缀后，每个汉字取拼音首字母（一二三四五六七八九按1-9），数字和英文字母原样保留。企业/工程用机构名称；标段用项目简称；劳务公司用「标段简称+公司名称」。若重名则末尾加2、3、4…，按规则登不上时请联系超管员在本页查看实际用户名。初始密码12345678。',
    organUser: {
      name: 'organUser',
      title: (params) => {
        return params.pageStatus === 'edit' ? '编辑机构用户' : '配置用户角色'
      },
      editFun: 'user/editUser',
      getParentFun: 'user/getSystemOrganUser',
      formParams: {
        uid: '',
        userName: '',
        passwd: '',
        orgCode: ''
      },
      formRules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            min: 1,
            max: 18,
            message: '用户名应在长度在 1 到 18 个字符',
            trigger: 'blur'
          },
          {
            pattern: /\w/,
            message: '用户名必须由字母或数字组成',
            trigger: 'blur'
          }
        ],
        passwd: [
          {
            min: 8,
            max: 16,
            message: '密码应在长度在 8 到 16 个字符',
            trigger: 'blur'
          }
        ],
        checkPasswd: [
          {
            validator: (params) => {
              return params.validate.validateCheckPasswd
            },
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'userName',
          label: '用户名',
          type: 'input',
          placeholder: '请输入18位以内字母及数字组合用户名',
          span: 18
        },
        {
          key: 'orgCode',
          label: '机构名称',
          type: 'input',
          disabled: true,
          span: 18
        },
        {
          key: 'passwd',
          label: '修改密码',
          type: 'input',
          placeholder: '请输入修改后密码，8至16位字母及数字组合，不修改不用填',
          inputType: 'password',
          span: 18
        },
        {
          key: 'checkPasswd',
          label: '确认密码',
          type: 'input',
          placeholder: '请再次输入修改后密码',
          inputType: 'password',
          span: 18
        }
      ]
    }
  },
  personUser: {
    name: 'personUser',
    theme: '个人用户',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'dialogForm',
      'setRole'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    detailPage: [
      {
        buttonNames: ['新增', '批量新增'],
        type: 'dialogForm',
        name: 'personUser'
      },
      {
        buttonName: '编辑',
        type: 'dialogForm',
        name: 'personUser',
        checkType: 'useRowData'
      },
      {
        buttonName: '配置角色',
        type: 'other',
        name: 'setRolse',
        step: 'setRolseInfo',
        theme: 'user',
        label: '配置角色信息',
        checkType: 'useRowData'
      }
    ],
    rowKey: 'userUid',
    headButtons: setCheckButtons(['新增', '批量新增', '批量封禁', '批量解禁']),
    selectColumn: true,
    getListFun: 'user/getSystemPersonUser',
    deleteFun: 'person/purgePersonUser',
    queryParams: {
      queryName: ''
    },
    selectData: [
      {
        key: 'queryName',
        label: '关键词',
        type: 'input',
        placeholder: '手机号码/用户名/姓名'
      }
    ],
    rowData: (params) => {
      return params.state.user.personUserList.result
    },
    rowTotal: (params) => {
      return params.state.user.personUserList.totalSize
    },
    columns: [
      { prop: 'userName', label: '用户名', width: '' },
      { prop: 'name', label: '姓名', width: '' },
      { prop: 'telphoneNum', label: '手机号码', width: '' },
      { prop: 'roleGroupName', label: '用户角色', width: '520px' },
      {
        prop: 'accountStatusName',
        label: '状态',
        width: '120px',
        tag: [
          { label: '正常', type: 'success' },
          { label: '封禁', type: 'danger' },
          { label: '个人机构封禁', type: 'warning' }
        ]
      },
      {
        prop: 'archiveStatusName',
        label: '档案状态',
        width: '110px',
        tag: [
          { label: '未关联', type: 'info' },
          { label: '已关联', type: 'success' },
          { label: '已封存', type: 'danger' }
        ]
      },
      {
        label: '操作',
        buttons: setTableButtons(['编辑', '封禁', '解禁', '删除', '配置角色', '密码初始化']),
        width: '440px'
      }
    ],
    hasPagination: true,
    personUser: {
      title: (params) => {
        if (params.pageStatus === 'add') {
          return '新增个人用户'
        } else if (params.pageStatus === 'edit') {
          return '编辑个人用户'
        } else if (params.pageStatus === 'batch') {
          return '批量新增用户'
        }
      },
      addFun: 'user/addPersonUser',
      editFun: 'user/editUser',
      getParentFun: 'user/getSystemPersonUser',
      formParams: {
        uid: '',
        userName: '',
        passwd: '',
        currentOrgUid: '',
        telphoneNum: '',
        personName: ''
      },
      formRules: {
        userName: [
          {
            required: (params) => {
              return params.pageStatus !== 'batch'
            },
            message: '请输入用户名',
            trigger: 'blur'
          },
          {
            pattern: (params) => {
              return params.pageStatus !== 'batch' ? /\w{1,18}/ : null
            },
            message: '用户名必须由字母或数字组成',
            trigger: 'blur'
          }
        ],
        passwd: [
          {
            required: (params) => {
              return params.pageStatus === 'add'
            },
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 8,
            max: 16,
            message: '密码应在长度在 8 到 16 个字符',
            trigger: 'blur'
          }
        ],
        checkPasswd: [
          {
            required: (params) => {
              return params.pageStatus === 'add'
            },
            message: '请再次输入密码',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.pageStatus !== 'batch'
                ? params.validate.validateCheckPasswd
                : null
            },
            trigger: 'blur'
          }
        ],
        telphoneNum: [
          {
            required: (params) => {
              return params.pageStatus !== 'edit'
            },
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            pattern: (params) => {
              return params.pageStatus !== 'batch'
                ? /^1(3|4|5|6|7|8|9)\d{9}$/
                : null
            },
            message: '手机号码输入不合法',
            trigger: 'blur'
          }
        ]
      },
      formData: [
        {
          key: 'userName',
          isShow: (params) => {
            return params.pageStatus !== 'batch'
          },
          label: '用户名',
          placeholder: '请输入18位以内字母及数字组合用户名',
          type: 'input',
          span: 18
        },
        {
          key: 'personName',
          isShow: (params) => {
            return params.pageStatus !== 'batch'
          },
          label: '姓名',
          placeholder: '选填，未绑定档案时列表显示该姓名',
          type: 'input',
          span: 18
        },
        {
          key: 'telphoneNum',
          label: '手机号码',
          type: 'input',
          placeholder: (params) => {
            return params.pageStatus === 'batch'
              ? '请输入由手机号码组成的字符，手机号码之间空开或用其他非数字字符隔开'
              : null
          },
          inputType: (params) => {
            return params.pageStatus === 'batch' ? 'textarea' : ''
          },
          autosize: (params) => {
            return params.pageStatus === 'batch'
              ? { minRows: 8, maxRows: 10 }
              : null
          },
          span: 18
        },
        {
          key: 'currentOrgUid',
          label: '默认角色组',
          isShow: (params) => {
            return params.pageStatus === 'edit'
          },
          type: 'select',
          options: (params) => {
            const userRoles = resetAttribute(
              params.state.user.userRoles,
              'label',
              'organizeUid'
            )
            return userRoles
          },
          checkByValue: true,
          span: 18
        },
        {
          key: 'passwd',
          isShow: (params) => {
            return params.pageStatus !== 'batch'
          },
          label: '密码',
          type: 'input',
          placeholder: (params) => {
            return params.pageStatus === 'add'
              ? '请输入8至16位字母及数字组合密码'
              : '请输入修改后密码，8至16位字母及数字组合，不修改不用填'
          },
          inputType: 'password',
          span: 18
        },
        {
          key: 'checkPasswd',
          isShow: (params) => {
            return params.pageStatus !== 'batch'
          },
          label: '确认密码',
          type: 'input',
          placeholder: (params) => {
            return params.pageStatus === 'add'
              ? '请再次输入密码'
              : '请再次输入修改后密码'
          },
          inputType: 'password',
          span: 18
        }
      ]
    }
  },
  orgAdmin: {
    name: 'orgAdmin',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'setRole'],
    rowKey: 'userUid',
    detailPage: [
      {
        buttonName: '新增',
        type: 'stepForm',
        name: 'orgAdmin',
        theme: 'user',
        step: 'orgAdminInfo',
        label: '新增管理员',
        checkType: 'detailData',
        detailData: {
          uid: '',
          userName: '',
          name: '',
          telphoneNum: '',
          userTypeName: ''
        }
      },
      {
        buttonName: '配置角色',
        type: 'other',
        name: 'setRolse',
        step: 'setRolseInfo',
        theme: 'user',
        label: '配置角色信息',
        checkType: 'useRowData'
      }
    ],
    headButtons: setCheckButtons(['新增']),
    getListFun: 'user/getOrgAdmin',
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      queryName: ''
    },
    selectData: [
      {
        key: 'queryName',
        label: '关键词',
        type: 'input',
        placeholder: '姓名或机构名称'
      }
    ],
    tagInfo:
      '新增管理员即是在机构下普通用户中选择并为其配置添加相应管理权限；通过配置角色功能可以增删更改管理员的相应角色，当所有管理权限被删除仅余普通权限时将自动从管理员列表中清除',
    rowData: (params) => {
      return params.state.user.orgAdmin
    },
    hasPagination: true,
    columns: [
      { prop: 'userName', label: '用户名', width: '' },
      { prop: 'userCode', label: '姓名/机构名称', width: '200px' },
      {
        prop: 'userTypeName',
        label: '用户类型',
        tag: (params) => {
          return params.dictionarys.userType
        }
      },
      { prop: 'roleName', label: '用户角色', width: '500px' },
      {
        label: '操作',
        buttons: setTableButtons(['配置角色', '密码初始化'])
      }
    ]
  }
}

export default user
